import { ReactNode } from 'react';
import { Avatar } from '@tempmee/react';
import { IUser } from '~/models/User';
import { getOfficeAvatarUrl } from '~/utils/OfficeUtils';

interface IOfficeSwitcherHeaderProps {
  avatar: ReactNode | undefined;
  avatarBadge: string | undefined;
  title: string;
  subtitle: string | undefined;
}

/**
 * Shared Sidebar.Header props for the office switcher trigger and dropdown,
 * so both always render the same identity. The master office is badged ADMIN.
 */
export const getOfficeSwitcherHeaderProps = (
  selectedChildOffice: IUser | null | undefined,
  masterOfficeId: string | undefined,
): IOfficeSwitcherHeaderProps => {
  if (!selectedChildOffice) {
    return { avatar: undefined, avatarBadge: undefined, title: '', subtitle: undefined };
  }

  return {
    avatar: (
      <Avatar src={getOfficeAvatarUrl(selectedChildOffice.profile_image)} size="2xl" alt="office" />
    ),
    avatarBadge: selectedChildOffice.id === masterOfficeId ? 'ADMIN' : undefined,
    title: selectedChildOffice.office_name ?? '',
    subtitle: selectedChildOffice.address?.[0]?.formatted_address,
  };
};
